import UserEdit from '@/components/user/edit/UserEdit.vue'
import EmailManualSend from '@/components/configs/emails/manualsend/EmailManualSend.vue'
import { mapState } from 'vuex'

const defaultFilterValues = {
  userName: '',
  clientName: '',
  email: '',
  isDeleted: [0],
  isLdapUser: [],
  isContactPerson: [],
  roles: [],
  managers: [],
  phones: ''
};

export default {
  name: 'UserList',
  components: {
    UserEdit,
    EmailManualSend
  },
  data () {
    return {
      loading: true,
      currentReq: null,
      tableItems: [],
      filterValues: this.BasicHelper.cloneObject(defaultFilterValues),
      tableSorting: { item: 'name', direction: 'asc' },
      paging: { limit: 20, page: 1, total: 0, pages: 0 }
    };
  },
  computed: {
    ...mapState(['config']),
    tableHeaders () {
      const headers = [
        { key: 'name', label: this.$t('user.name'), filterKey: 'userName', sortable: true },
        { key: 'phones', label: this.$t('user.phone'), format: 'formatPhones', filterKey: 'phones' },
        { key: 'email', label: this.$t('user.email'), format: 'formatEmail', filterKey: 'email', sortable: true },
        { key: 'clients', label: this.$t('user.clients'), format: 'formatArraySingleParam', paramKey: 'name', filterKey: 'clientName' },
        { key: 'jobPosition.' + this.$i18n.locale, label: this.$t('user.jobPosition') },
        { key: 'roles', label: this.$t('user.roles'), format: 'formatArraySingleParam', paramKey: 'name' },
        { key: 'isLdapUser', label: this.$t('user.isLdapUser'), format: 'formatYesNo' },
        { key: 'isContactPerson', label: this.$t('user.isContactPerson'), format: 'formatYesNo' },
        { key: 'seminarRejectInvite', label: this.$t('user.seminarRejectInvite'), format: 'formatYesNo' }
      ];
      if (this.canEdit) {
        const actions = [
          { label: this.$t('menu.user.edit'), emit: 'editItem', icon: 'edit', bicon: 'pencil-fill' },
          { label: this.$t('menu.user.delete'), emit: 'deleteItem', icon: 'delete', bicon: 'trash', ifconfig: { param: 'deleted_at', value: null } },
          { label: this.$t('menu.user.restore'), emit: 'restoreItem', icon: 'restore', bicon: 'clock-history', ifconfig: { param: 'deleted_at', value: null, notCheck: true } }
        ];
        if (this.ApiRequest.userHasPermission('simulate-users')) {
          actions.unshift({ label: this.$t('menu.user.simulate'), emit: 'simulateUser', bicon: 'eye-fill', ifconfig: { useFunc: true, func: function (el) { return !(el.roles && el.roles.find(role => role.name === 'admin')) } } })
        }
        headers.push({ key: 'actions', label: '', actions: actions, class: 'col-width-large' });
      }
      return headers;
    },
    tableExpandConfig () {
      return { component: 'UserListExpand' };
    },
    tableFilterConfig () {
      const filters = { };
      filters.userName = { type: 'text', label: this.$t('user.name'), colOnlyFilter: true };
      filters.phones = { type: 'text', label: this.$t('user.phones'), colOnlyFilter: true };
      filters.email = { type: 'text', label: this.$t('user.email'), colOnlyFilter: true };
      filters.clientName = { type: 'text', label: this.$t('client.name'), colOnlyFilter: true };
      filters.roles = { type: 'checkbox', label: this.$t('user.roles'), options: this.roleOptions };
      filters.isDeleted = { type: 'checkbox', label: this.$t('general.filters.deleted'), options: this.yesNoOptions, class: 'col-md-2' };
      filters.isLdapUser = { type: 'checkbox', label: this.$t('user.isLdapUser'), options: this.yesNoOptions, class: 'col-md-2' };
      filters.isContactPerson = { type: 'checkbox', label: this.$t('user.isContactPerson'), options: this.yesNoOptions, class: 'col-md-2' };
      filters.managers = { type: 'checkbox', label: this.$t('client.manager'), options: this.managerOptions, defaultValue: [], valueField: 'api_id' };
      return filters;
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-settings');
    },
    yesNoOptions () {
      return this.BasicHelper.yesNoOptions();
    },
    roleOptions () {
      return this.config.roles;
    },
    requestPath () {
      let path = 'user/list?perPage=' + this.paging.limit + '&page=' + this.paging.page;
      if (this.tableSorting.item) {
        path += '&order=' + this.tableSorting.item + ',' + this.tableSorting.direction;
      }
      return path;
    },
    tableActions () {
      const actions = { download: true };
      if (this.canEdit) {
        actions.add = { title: this.$t('menu.user.new') };
      }
      actions.extra = [
        { event: 'openSendEmail', class: 'btn-secondary', icon: 'envelope-fill', title: this.$t('menu.config.emails.messages.new-info') }
      ];
      return actions;
    },
    managerOptions () {
      return this.$store.getters.getConfigOptions('managers');
    }
  },
  methods: {
    getTableData () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.loading = true;
      const self = this;
      this.currentReq = this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_POST, this.filterValues, function (response) {
        if (response.data) {
          self.tableItems = response.data;
          self.paging = response.paging;
          self.loading = false;
        }
      });
    },
    updateSort (item, desc) {
      this.tableSorting.item = item;
      if (desc) {
        this.tableSorting.direction = 'DESC';
      } else {
        this.tableSorting.direction = 'ASC';
      }
      this.getTableData();
    },
    setDeleted (el, isDeleted) {
      this.loading = true;
      const self = this;
      this.ApiRequest.request('user/deleted', this.ApiRequest.REQUEST_POST, { id: el.api_id, deleted: isDeleted }, function (response) {
        if (response.error) {
          self.ApiRequest.displayErrorDialog(response, self);
          self.loading = false;
        } else {
          self.itemUpdated();
        }
      });
    },
    itemUpdated () {
      this.$emit('saved');
      this.getTableData();
    },
    editItem (el) {
      this.$refs.editElFrm.show(el);
    },
    deleteItem (el, approved) {
      if (approved) {
        this.setDeleted(el, 1);
      } else {
        this.$refs.itemDeleteMsgBox.show(el, this.$t('user.deleteTitle'), this.$t('user.deleteMessage', { userName: el.name }))
      }
    },
    simulateUser (el, approved = false) {
      if (approved) {
        const self = this;
        this.ApiRequest.request('user/loginas/' + el.api_id, this.ApiRequest.REQUEST_GET, {}, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.$session.set('originalAccessToken', self.$session.get('accessToken'));
            self.$session.set('accessToken', response.data.token);
            self.$session.set('uuid', response.data.user.api_id);
            self.$session.set('user', response.data.user.name);
            self.$session.set('email', response.data.user.email);
            self.$session.set('locale', response.data.user.defaultLang);
            self.$session.set('permissions', response.data.user.permissions);
            self.$session.set('client_permissions', response.data.user.client_permissions);
            self.$session.set('roles', response.data.user.roles.map(a => a.name));
            self.$session.set('isSimUser', true);
            self.$root.$i18n.locale = response.data.user.defaultLang;
            self.$store.dispatch('loadConfig');
            self.$store.dispatch('sessionUpdated');
            self.$router.push('/home');
          }
        });
      } else {
        this.$refs.userSimulateMsgBox.show(el, this.$t('user.simulate.title'), this.$t('user.simulate.message', { userName: el.name, email: el.email }))
      }
    },
    restoreItem (el) {
      this.setDeleted(el, 0);
    },
    changePage (pageNr) {
      this.paging.page = pageNr;
      this.getTableData();
    },
    download () {
      const self = this;
      self.$refs.tableview.setDownloading(1);
      this.ApiRequest.request(this.requestPath + '&download=1', this.ApiRequest.REQUEST_DOWNLOAD, {}, function () {
        self.$refs.tableview.setDownloading(0);
      });
    },
    openSendEmail () {
      this.$refs.manualSendEmail.show();
    }
  },
  mounted () {
    this.getTableData();
  }
}
